var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckboxUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-1.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,1.75 C12.2779305,1.75 14.3405077,2.67348038 15.8335661,4.16653878 C17.3264871,5.65945976 18.25,7.72186805 18.25,10 C18.25,12.2782375 17.3266241,14.3407407 15.8336824,15.8336824 C14.3407407,17.3266241 12.2782375,18.25 10,18.25 C7.7217625,18.25 5.65925931,17.3266241 4.16631759,15.8336824 C2.67337586,14.3407407 1.75,12.2782375 1.75,10 C1.75,7.7217625 2.67337586,5.65925931 4.16631759,4.16631759 C5.65925931,2.67337586 7.7217625,1.75 10,1.75 Z",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fillRule: "nonzero"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxUnchecked);
export default __webpack_public_path__ + "static/media/checkbox-unchecked.e03f8c15bfd9182a46c67729d691d984.svg";
export { ForwardRef as ReactComponent };